import React, {Component} from 'react';
import { TextField, TextFieldIcon, TextFieldHelperText } from 'rmwc/TextField';
import { Grid, GridCell, GridInner } from 'rmwc/Grid';
import { FormField } from 'rmwc/FormField';
import { Slider } from 'rmwc/Slider';
import { Chip, ChipText, ChipIcon, ChipSet } from 'rmwc/Chip';
import { Radio } from 'rmwc/Radio';
import { Button, ButtonIcon } from 'rmwc/Button';
import {
  Card,
  CardPrimaryAction,
  CardMedia,
  CardAction,
  CardActions,
  CardActionButtons,
  CardActionIcons
} from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import {Icon} from 'rmwc/Icon';
import { Select } from 'rmwc/Select';


export default class InputField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lat: '',
      lon: '',
      sysVoltage: '',
      sliderValue2: 75,
      energy: '',
      storage: '',
      battVoltage: '',
      battCapacity: '',
      panelSize: '',
      dod: '',
      mounting: 'ground'

    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({[name]: value}, () => {console.log("Name: ", name, "Value: ", value )});
  }

  handleSubmit(event) {
    //alert('Input was submitted: ' + this.state.lat);
    this.props.getInput(this.state.lat, this.state.lon, this.state.sysVoltage, this.state.sliderValue2, this.state.energy, this.state.storage, this.state.battVoltage, this.state.battCapacity, this.state.panelSize, this.state.dod, this.state.mounting);

    event.preventDefault();
  }

  render() {
    return(
      <Grid>
        {/* An outlined TextField */}
        <GridCell span="4">
          <TextField label="Latitude"
            //required="true"
            type="number"
            name="lat"
            value={this.state.lat}
            onChange={this.handleInputChange}
            withLeadingIcon="gps_fixed"
          />
          <TextFieldHelperText>Latitude in "decimal degree", i.e 45.56789</TextFieldHelperText>
        </GridCell>
        <GridCell span="4">
          <TextField label="Longitude"
            //required="true"
            type="number"
            name="lon"
            value={this.state.lon}
            onChange={this.handleInputChange}
            withLeadingIcon="gps_fixed"
           />
          <TextFieldHelperText>Longitude in "decimal degree", i.e 18.35432</TextFieldHelperText>
        </GridCell>
        <GridCell span="4">
          <TextField label="PV panel power"
            type="number"
            name="panelSize"
            value={this.state.panelSize}
            onChange={this.handleInputChange}
            withLeadingIcon="power"
          />
          <TextFieldHelperText>in "W" as peak power i.e: 325</TextFieldHelperText>
        </GridCell>
        <GridCell span="4">
          <TextField label="System voltage"
            type="number"
            name="sysVoltage"
            value={this.state.sysVoltage}
            onChange={this.handleInputChange}
            withLeadingIcon="flash_on"
          />
          <TextFieldHelperText>in "V", i.e 48</TextFieldHelperText>
        </GridCell>
        <GridCell span="4">
          <TextField label="Storage back-up time"
            type="number"
            name="storage"
            value={this.state.storage}
            onChange={this.handleInputChange}
            withLeadingIcon="timelapse"
          />
          <TextFieldHelperText>in "hours" i.e: 72</TextFieldHelperText>
        </GridCell>
        <GridCell span="4">
          <Select
            box
            label="Battery voltage"
            name="battVoltage"
            defaultValue=""
            onChange={this.handleInputChange}
            >
              <option value="" disabled></option>
              <option value="12V">
                12V batteries
              </option>
              <option value="2V">
                2V batteries
              </option>
            </Select>
          </GridCell>
        <GridCell span="6">
          {/* Controlled with change handler */}
          <Radio
            value="roof"
            checked={this.state.mounting === 'roof'}
            onChange={evt => this.setState({mounting: evt.target.value})}>
            Roof mounted
          </Radio>
        </GridCell>
        <GridCell span="6">
          <Radio
            value="ground"
            checked={this.state.mounting === 'ground'}
            onChange={evt => this.setState({mounting: evt.target.value})}
            >
            Ground array

          </Radio>
        </GridCell>

        <GridCell span="12">
          {/* With Icons */}
          <ChipSet>
            <Chip>
              <ChipIcon leading use="battery_alert" />
              <ChipText>D.O.D % </ChipText>
            </Chip>
          </ChipSet>
          <Slider
            value={this.state.sliderValue2 === undefined ? 150 : this.state.sliderValue2}
            onChange={evt => this.setState({sliderValue2: evt.detail.value})}
            onInput={evt => this.setState({sliderValue2: evt.detail.value})}
            discrete
            min={5}
            max={100}
            step={5}
          />
        </GridCell>
      <GridCell span="12">
        <Button raised onClick={this.handleSubmit}>Calculate</Button>
      </GridCell>
      </Grid>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/InputField/InputField.js